import { z } from "zod";
import { BASE, ISO } from "./common.ts";

/** How exact a project date or an initiative target is: a day, a month, a quarter, a half year or a year (X19-2305a). */
export const DATE_PRECISION = z.enum(["day", "month", "quarter", "half", "year"]);
export type DatePrecision = z.infer<typeof DATE_PRECISION>;

/** Where an initiative stands: proposed, planned, active, completed or canceled. Its health is rolled up from its projects. */
export const INITIATIVE_STATUS = z.enum(["proposed", "planned", "active", "completed", "canceled"]);
export type InitiativeStatus = z.infer<typeof INITIATIVE_STATUS>;

/** An objective that groups projects. A sub-initiative names its parent (one level deep); a top-level one has parentId null. */
export const INITIATIVE = BASE.extend({
  name: z.string(),
  status: INITIATIVE_STATUS,
  ownerId: z.string(),
  targetDate: ISO.nullable(),
  targetPrecision: DATE_PRECISION,
  parentId: z.string().nullable(),
  projectIds: z.array(z.string()),
});
export type Initiative = z.infer<typeof INITIATIVE>;
